import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
    width: 100%;
`

export const SelectContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 2rem;
    margin-bottom: 1.4rem;
    margin-top: .3rem;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 1rem;
    }
`

export const CustomSelect = styled(SelectMui)`
    height: 3rem !important;
`

export const CustomTextField = styled(TextFieldMui)`
    width: 30rem;
    margin: 0 !important;
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;
    height: 2.8rem !important;
    margin: 0 !important;
`

export const CheckinOrdersContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 60vh;
    justify-content: space-between;
`
